import { render, staticRenderFns } from "./CustomQueryList.vue?vue&type=template&id=2fe9cf1b&scoped=true&"
import script from "./CustomQueryList.vue?vue&type=script&lang=js&"
export * from "./CustomQueryList.vue?vue&type=script&lang=js&"
import style0 from "./CustomQueryList.vue?vue&type=style&index=0&id=2fe9cf1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fe9cf1b",
  null
  
)

export default component.exports